export default __webpack_public_path__ + "static/media/men-women.be474834.svg";